// ©2024 Austin App House. All rights reserved.
import React from 'react';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import Select from '../../layout/CustomSelect';
import { connect } from 'react-redux';
import { dashboard as dashboardSelectStyle, dashboardSelectClassNames } from '../../../utils/customSelectStyle';
import { workOrderTypes } from '../../../utils/constans';
import { toggleModal } from '../../../storage/actions/modalsActions';
import { setFiltersObject } from '../../../storage/actions/workOrdersActions';
import getWorkOrderStatusSet from '../../../utils/getWorkOrderStatusSet';
import FiltersModalShell from './FiltersModalShell';

class ModalWOFilters extends React.Component {
  constructor(props) {
    super(props);
    const filters = props.filters || {};
    const selectedWOTypes = getWorkOrderStatusSet(
      filters.selectedWOTypes,
      filters.needFilterByRouterStatus,
      filters.needFilterWithoutRouterStatus,
    );
    this.state = {
      form: {
        selectedCompanies: new Set(filters.selectedCompanies || []),
        contractorId: filters.contractorId || '',
        startDate: filters.startDate || {},
        endDate: filters.endDate || {},
        selectProject: filters.selectProject || '',
        selectCompany: filters.selectCompany || '',
        workOrderId: filters.workOrderId || '',
        workOrderTitle: filters.workOrderTitle || '',
        selectedWOTypes,
        cityName: filters.cityName || '',
        selectState: filters.selectState || '',
        zipCode: filters.zipCode || '',
        selectCountry: filters.selectCountry || '',
        selectContractorCountry: filters.selectContractorCountry || '',
        siteId: filters.siteId || '',
        siteName: filters.siteName || '',
        payRate: filters.payRate || {},
        createdDate: filters.createdDate || {},
        assignedDate: filters.assignedDate || {},
        completedDate: filters.completedDate || {},
        approvedDate: filters.approvedDate || {},
        paidDate: filters.paidDate || {},
        selectedWorkTypes: new Set(filters.selectedWorkTypes || []),
        payLocation: filters.payLocation || '',
      },
      companies: [],
      projects: [],
      workOrderTypes,
      stateArray: [],
      countries: [],
      rateTypes: [
        {
          value: 'Hour',
          label: 'Hour',
        },
        {
          value: 'Device',
          label: 'Device',
        },
        {
          value: 'Site',
          label: 'Site / Flat',
        },
      ],
      workTypes: [],
      payLocations: [
        {
          value: 'all',
          label: 'All',
        },
        {
          value: 'payOutsideOfApp',
          label: 'Pay outside app',
        },
        {
          value: 'payWithinApp',
          label: 'Pay within app',
        },
      ],
    };
  }

  componentDidMount() {
    this.getCompanies();
    this.getCountries();
    this.getWorkTypes();
    this.getProjects();
    this.getWOCompanies();
  }

  componentDidUpdate(prevProps, prevState) {
    if ([...prevState.form.selectedCompanies].length
        !== [...this.state.form.selectedCompanies].length) {
      this.getWOCompanies();
      this.getProjects();
    }
  }

  getCompanies = () => {
    axios.get('/api/admin/companies')
      .then(res => {
        if (!res.data?.payload?.companies) throw new Error('Can\'t get list of companies!');
        const { companies } = res.data.payload;
        this.setState({ companies });
      })
      .catch(error => {
        console.error(error);
      });
  }

  resetFilters = () => {
    this.setState({
      form: {
        selectedCompanies: '',
        contractorId: '',
        startDate: {},
        endDate: {},
        selectProject: '',
        selectCompany: '',
        workOrderId: '',
        workOrderTitle: '',
        selectedWOTypes: new Set(),
        cityName: '',
        selectState: '',
        zipCode: '',
        selectCountry: '',
        selectContractorCountry: '',
        siteId: '',
        siteName: '',
        payRate: {},
        createdDate: {},
        assignedDate: {},
        completedDate: {},
        approvedDate: {},
        paidDate: {},
        selectedWorkTypes: new Set(),
        payLocation: '',
      },
    });
  }

  handlerOnChange = ({ name, value }) => {
    this.setState(
      cur => ({ form: { ...cur.form, [name]: value || '' } }),
      () => {
        if (name === 'selectCountry') this.getStates();
      },
    );
  }

  handlerSetChanges = ({ target }) => {
    const newSet = new Set([...this.state.form[target.name]]);
    const command = target.checked ? 'add' : 'delete';
    newSet[command](target.value);
    this.setState(cur => ({ form: { ...cur.form, [target.name]: newSet } }));
  }

  handlerObjectChanges = (field, name, value) => {
    this.setState(cur => ({
      form: { ...cur.form, [field]: { ...cur.form[field], [name]: value || '' } },
    }));
  }

  closeModal = () => this.props.toggleModal(false, 'filtersModal');

  handlerAccept = event => {
    event.preventDefault();
    const filters = this.getFilters();
    this.props.getFilters(filters);
    this.closeModal();
  }

  getFilters = () => {
    const fields = Object.keys(this.state.form);
    if (!fields.length) return null;
    const result = {};
    fields
      .filter(key => (
        this.state.form[key] !== ''
            && (
              !(this.state.form[key] instanceof Set)
                || this.state.form[key].size > 0
            )
            && (
              !(this.state.form[key] instanceof Object)
                || (this.state.form[key] instanceof Set)
                || (this.state.form[key] instanceof Date)
                || this.state.form[key].from
                || this.state.form[key].to
                || this.state.form[key].value
                || this.state.form[key].length
            )
      ))

      .forEach(key => {
        if (this.state.form[key] instanceof Set) {
          const newSet = new Set([...this.state.form[key]]);
          if (key === 'selectedWOTypes' && newSet.has('routed')) {
            result.needFilterByRouterStatus = {
              published: newSet.has('published'),
              draft: newSet.has('draft'),
            };
            newSet.add('published');
            newSet.add('draft');
          }
          if (
            key === 'selectedWOTypes'
                && !newSet.has('routed')
                && (newSet.has('published') || newSet.has('draft'))
          ) result.needFilterWithoutRouterStatus = true;
          newSet.delete('routed');
          result[key] = [...newSet];
          return;
        }
        if (this.state.form[key] instanceof Date) {
          const newDate = {};
          newDate.from = this.state.form[key];
          newDate.to = new Date(new Date(this.state.form[key]).setHours(24, 0, 0, -1));
          result[key] = newDate;
          return;
        }
        result[key] = this.state.form[key];
      });
    return result;
  }

  getCountries = () => {
    axios.get('/api/address/getAllCountries')
      .then(res => {
        if (res.data.length && res.data.length > 0) {
          return this.setState({
            countries: res.data.map(item => ({
              ...item,
              label: item.name,
              value: item.isoCode,
            })),
          }, this.getStates);
        }
        throw new Error('Can\'t get list of countries!');
      })
      .catch(error => {
        console.error(error);
      });
  }

  getStates = () => {
    axios.get('/api/address/getStatesOfCountry', {
      params: { countryId: this.state?.form?.selectCountry?.value || '' },
    })
      .then(res => {
        this.setState({
          stateArray: res.data?.payload?.states || [],
        });
      })
      .catch(error => {
        console.error(error);
      });
  }

  getWorkTypes = () => {
    axios.get('/api/users/getTools')
      .then(res => {
        if (res.data.Tools && res.data.Tools.length > 0) {
          return this.setState({ workTypes: res.data.Tools });
        }
        throw new Error('Can\'t get list of work types!');
      })
      .catch(error => {
        console.error(error);
      });
  }

  createUrlParamsBasedOnCompanies = (selectedCompanies) => {
    const companies = [...selectedCompanies].map((item) => item.value);
    return ({ companies });
  }

  // eslint-disable-next-line consistent-return
  getProjects = () => {
    const params = this.createUrlParamsBasedOnCompanies(this.state.form.selectedCompanies);
    if (!params) return this.setState({ projects: [] });
    axios.get('/api/projects', { params })
      .then(res => {
        if (res.data?.payload?.data?.length) {
          return this.setState({
            projects: res.data.payload.data.map(item => ({
              label: item.name,
              value: item._id,
            })),
          });
        }
        throw new Error('Can\'t get list of projects!');
      })
      .catch(error => {
        console.error(error);
      });
  }

  // eslint-disable-next-line consistent-return
  getWOCompanies = () => {
    const params = this.createUrlParamsBasedOnCompanies(this.state.form.selectedCompanies);
    if (!params) return this.setState({ woCompanies: [] });
    axios.get('/api/wo-companies', { params })
      .then(res => {
        if (res.data?.payload?.data?.length) {
          return this.setState({
            woCompanies: res.data.payload.data.map(item => ({
              label: item.name,
              value: item._id,
            })),
          });
        }
        throw new Error('Can\'t get list of companies!');
      })
      .catch(error => {
        console.error(error);
      });
  }

  renderDateRangeRow = (label, fieldKey, range) => (
    <div className="field_row">
      <div className="field_name">{label}</div>
      <div className="field_block">
        <div className="dashboard-date-range">
          <DatePicker
            className="dashboard-input"
            selected={range.from}
            onChange={date => this.handlerObjectChanges(fieldKey, 'from', date)}
            dateFormat="MM/dd/yyyy"
            placeholderText="From"
          />
          <span className="dashboard-date-range-sep">–</span>
          <DatePicker
            className="dashboard-input"
            selected={range.to}
            onChange={date => this.handlerObjectChanges(fieldKey, 'to', date)}
            dateFormat="MM/dd/yyyy"
            placeholderText="To"
          />
        </div>
      </div>
    </div>
  );

  render() {
    const {
      companies,
      projects,
      woCompanies,
      workOrderTypes,
      stateArray, countries,
      rateTypes,
      workTypes,
      payLocations,
    } = this.state;
    const {
      selectedCompanies,
      contractorId,
      startDate,
      endDate,
      selectProject,
      selectCompany,
      workOrderId, workOrderTitle,
      selectedWOTypes,
      cityName, selectState, zipCode, selectCountry, selectContractorCountry,
      siteId, siteName,
      payRate,
      createdDate, assignedDate, completedDate, approvedDate, paidDate, selectedWorkTypes,
      payLocation,
    } = this.state.form;

    return (
      <FiltersModalShell
        title="Filters"
        onClose={this.closeModal}
        footer={(
          <>
            <button
              type="button"
              className="dashboard-btn dashboard-btn--secondary"
              onClick={this.resetFilters}
            >
              Reset
            </button>
            <button
              type="button"
              className="dashboard-btn dashboard-btn--primary"
              onClick={this.handlerAccept}
            >
              Apply
            </button>
          </>
        )}
      >
                <div className="field_row">
                  <div className="field_name">Company</div>
                  <div className="field_block dashboard-select-wrap">
                    <Select
                      isClearable
                      isSearchable
                      isMulti
                      closeMenuOnSelect={false}
                      options={companies}
                      value={[...selectedCompanies]}
                      styles={dashboardSelectStyle}
                      classNames={dashboardSelectClassNames}
                      onChange={value => this.handlerOnChange({ name: 'selectedCompanies', value: new Set(value || []) })}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Contractor ID</div>
                  <div className="field_block">
                    <input
                      type="text"
                      name="contractorId"
                      className="dashboard-input"
                      placeholder="Type contractor id"
                      value={contractorId}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>
                {this.renderDateRangeRow('Start Date', 'startDate', startDate)}
                {this.renderDateRangeRow('End Date', 'endDate', endDate)}
                <div className="field_row">
                  <div className="field_name">Customers</div>
                  <div className="field_block dashboard-select-wrap">
                    <Select
                      isClearable
                      isSearchable
                      options={woCompanies}
                      value={selectCompany}
                      styles={dashboardSelectStyle}
                      classNames={dashboardSelectClassNames}
                      onChange={value => this.handlerOnChange({ name: 'selectCompany', value })}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Project</div>
                  <div className="field_block dashboard-select-wrap">
                    <Select
                      isClearable
                      isSearchable
                      isMulti
                      options={projects}
                      value={[...selectProject]}
                      styles={dashboardSelectStyle}
                      classNames={dashboardSelectClassNames}
                      onChange={value => this.handlerOnChange({ name: 'selectProject', value: new Set(value || []) })}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Company WO ID</div>
                  <div className="field_block">
                    <input
                      type="text"
                      name="workOrderId"
                      className="dashboard-input"
                      placeholder="Type Company WO ID"
                      value={workOrderId}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">WO Title</div>
                  <div className="field_block">
                    <input
                      type="text"
                      name="workOrderTitle"
                      className="dashboard-input"
                      placeholder="Type work order title"
                      value={workOrderTitle}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">WO Status</div>
                  <div className="field_block dashboard-modal-checkbox-list">
                    {workOrderTypes && workOrderTypes.map(workOrderType => (
                      <label key={workOrderType.value} className="wo-check-btn check_btn dashboard-filter-check">
                        <input
                          type="checkbox"
                          id={workOrderType.value}
                          value={workOrderType.value}
                          name="selectedWOTypes"
                          checked={selectedWOTypes.has(workOrderType.value)}
                          onChange={this.handlerSetChanges}
                        />
                        <span>{workOrderType.title}</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">City</div>
                  <div className="field_block">
                    <input
                      type="text"
                      name="cityName"
                      className="dashboard-input"
                      placeholder="Type city name"
                      value={cityName}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">State</div>
                  <div className="field_block dashboard-select-wrap">
                    <Select
                      isClearable
                      isSearchable
                      options={stateArray}
                      value={selectState}
                      styles={dashboardSelectStyle}
                      classNames={dashboardSelectClassNames}
                      onChange={value => this.handlerOnChange({ name: 'selectState', value })}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Zip</div>
                  <div className="field_block">
                    <input
                      type="text"
                      name="zipCode"
                      className="dashboard-input"
                      placeholder="Type zip code"
                      value={zipCode}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Country</div>
                  <div className="field_block dashboard-select-wrap">
                    <Select
                      isClearable
                      options={countries}
                      value={selectCountry}
                      styles={dashboardSelectStyle}
                      classNames={dashboardSelectClassNames}
                      onChange={value => this.handlerOnChange({ name: 'selectCountry', value })}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Site ID</div>
                  <div className="field_block">
                    <input
                      type="text"
                      name="siteId"
                      className="dashboard-input"
                      placeholder="Type site id"
                      value={siteId}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Site Name</div>
                  <div className="field_block">
                    <input
                      type="text"
                      name="siteName"
                      className="dashboard-input"
                      placeholder="Type site name"
                      value={siteName}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Pay Rate</div>
                  <div className="field_block">
                    <div className="dashboard-date-range">
                      <input
                        type="text"
                        name="payRateFrom"
                        className="dashboard-input"
                        placeholder="From"
                        value={payRate.from}
                        onChange={event => this.handlerObjectChanges('payRate', 'from', parseFloat(event.target.value) || 0)}
                      />
                      <span className="dashboard-date-range-sep">–</span>
                      <input
                        type="text"
                        name="payRateTo"
                        className="dashboard-input"
                        placeholder="To"
                        value={payRate.to}
                        onChange={event => this.handlerObjectChanges('payRate', 'to', parseFloat(event.target.value) || 0)}
                      />
                    </div>
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Pay rate per</div>
                  <div className="field_block dashboard-select-wrap">
                    <Select
                      isClearable
                      options={rateTypes}
                      value={payRate.type}
                      styles={dashboardSelectStyle}
                      classNames={dashboardSelectClassNames}
                      onChange={value => this.handlerObjectChanges('payRate', 'type', value)}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Payment Location</div>
                  <div className="field_block dashboard-select-wrap">
                    <Select
                      options={payLocations}
                      value={payLocation}
                      styles={dashboardSelectStyle}
                      classNames={dashboardSelectClassNames}
                      onChange={value => this.handlerOnChange({ name: 'payLocation', value })}
                    />
                  </div>
                </div>
                <div className="field_row">
                  <div className="field_name">Contractors Country</div>
                  <div className="field_block dashboard-select-wrap">
                    <Select
                      isClearable
                      options={countries}
                      value={selectContractorCountry}
                      styles={dashboardSelectStyle}
                      classNames={dashboardSelectClassNames}
                      onChange={value => this.handlerOnChange({ name: 'selectContractorCountry', value })}
                    />
                  </div>
                </div>
                {this.renderDateRangeRow('Date Created', 'createdDate', createdDate)}
                {this.renderDateRangeRow('Date Assigned', 'assignedDate', assignedDate)}
                {this.renderDateRangeRow('Date Completed', 'completedDate', completedDate)}
                {this.renderDateRangeRow('Date Approved', 'approvedDate', approvedDate)}
                {this.renderDateRangeRow('Date Paid', 'paidDate', paidDate)}
                <div className="field_row">
                  <div className="field_name">Type(s) of work</div>
                  <div className="field_block dashboard-modal-checkbox-list">
                    {workTypes && workTypes.map(workType => (
                      <label key={workType} className="wo-check-btn check_btn dashboard-filter-check">
                        <input
                          type="checkbox"
                          id={workType}
                          value={workType}
                          name="selectedWorkTypes"
                          checked={selectedWorkTypes.has(workType)}
                          onChange={this.handlerSetChanges}
                        />
                        <span>{workType}</span>
                      </label>
                    ))}
                  </div>
                </div>
      </FiltersModalShell>
    );
  }
}

const mapDispatchToProps = {
  toggleModal,
  getFilters: setFiltersObject,
};

const mapStateToProps = state => ({
  filters: state?.workOrder?.filters,
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalWOFilters);
